import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";

const initState = {
  name:"",
  emailAddress:"",
  membershipTypeName:null,
  applicationStatus :null
};

export const ViewIndividualMemberData = {
  name: "View Individual",
  initialState: initState,
  section: [
    {
      title: "User Information Section",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },

      fields: [
        {
          id: "name ",
          label: "Name",
          Field_Name: "Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "name",
          fieldSetting: {
            placeholder: "Please Enter Name",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
          },
        },
        {
          id: "emailAddress",
          label: "Email Address",
          Field_Name: "Email Address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "emailAddress",
          fieldSetting: {
            placeholder: "Please Enter Email Address",
            allowSpace: true,
            textareaRows: 4,
          },
      
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
          },
        },
        {
          id: "membershipTypeName",
          label: "Membership Type",
          Field_Name: "Membership Type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "membershipTypeName",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [
            
            ],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
          },
        },
        {
          id: "applicationStatus",
          label: "Status",
          Field_Name: "Status",
          fieldType: FormFieldTypes.SELECT,
          dataField: "applicationStatus",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [
            ],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
          },
        },
      ],
    },
  ],
};


export const ViewIndividualMemberConfig = {
  columns: [
    {
      name: "Application Name",
      fieldName: "name",
      allowShort: false,
      // colStyle: {
      //   width: "15%",
      //   textAlign: "center",
      //   color: "color",
      //   // backgroundColor:"lightyellow"
      //   backgroundColor: "white"
      // }
    },
    {
      name: "Email Address",
      fieldName: "emailAddress",
      allowShort: false,
      // colStyle: {
      //   width: "40%",
      //   textAlign: "center",
      //   color: "color",
      //   // backgroundColor:"lightyellow"
      //   backgroundColor: "white"
      // }
    },
    {
      name: "Membership Type Name",
      fieldName: "membershipTypeName",
      allowShort: false,
      // colStyle: {
      //   width: "15%",
      //   textAlign: "center",
      //   color: "color",
      //   // backgroundColor:"lightyellow"
      //   backgroundColor: "white"
      // }
    },
    {
      name: "Status",
      fieldName: "status",
      allowShort: false,
      // colStyle: {
      //   width: "15%",
      //   textAlign: "center",
      //   color: "color",
      //   // backgroundColor:"lightyellow"
      //   backgroundColor: "white"
      // }
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
    },
    },


  ],
  allowEdit: false,
  isRowSelectable: true,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple"
  }
}